import { Routes, RouterModule } from '@angular/router';
import { LocalComponent } from './local.component';
import { AuthGuard } from 'app/main/pages/authentication/auth.guard';

const routes: Routes = [
  { 
    path:"local", 
    component:LocalComponent,
    canActivate: [AuthGuard]
  },
];

export const LocalRoutes = RouterModule.forChild(routes);
